import { FINANCE_DOCUMENTS_ROUTE } from '../../app/router/routes'
import { Navigate } from 'react-router-dom'

export default function StaffDocumentsPage() {
    return <Navigate to={FINANCE_DOCUMENTS_ROUTE.path} replace />
}
